import { FC, useState } from 'react';
import { AudienceDestinationSyncSuccessful } from './AudienceDestinationSyncSuccessful';
import { AudienceDestinationSync } from './AudienceDestinationSync';
import { DistributionChannelContent } from '@/models/distributionChannels';
import { BaseAudience } from '@/models/audiences';
import { CyclrTemplate } from '@/services/endpoints/integrations';

interface IAudienceAndDestinationSyncReviewStepProps {
  distributionChannelContent: DistributionChannelContent;
  selectedAudience: BaseAudience;
  selectedTemplate: CyclrTemplate;
  onSyncSuccessful: VoidFunction;
  prevStep: VoidFunction;
  onCancel: VoidFunction;
}

export const AudienceAndDestinationSyncReviewStep: FC<IAudienceAndDestinationSyncReviewStepProps> = ({
  selectedAudience,
  selectedTemplate,
  distributionChannelContent,
  onSyncSuccessful,
  prevStep,
  onCancel,
}) => {
  const [isSyncedSuccess, setIsSyncedSuccess] = useState<boolean>(false);

  const handleSyncedSuccesfull = () => {
    setIsSyncedSuccess(true);
    onSyncSuccessful();
  };

  return (
    <>
      {!isSyncedSuccess && (
        <AudienceDestinationSync
          selectedAudience={selectedAudience}
          selectedTemplate={selectedTemplate}
          distributionChannelContent={distributionChannelContent}
          prevStep={prevStep}
          onSyncSuccess={handleSyncedSuccesfull}
          onCancel={onCancel}
        />
      )}
      {isSyncedSuccess && <AudienceDestinationSyncSuccessful />}
    </>
  );
};
